import { Play } from 'lucide-react';
import ReactPlayerImport from 'react-player';
import {
  convertVideoFileWithCloudinary,
  getVideoCoverImage
} from 'lib/media/videoHelper';
import type { PinRendererProps } from './pinMediaRenderer';

// CJS package: Vite/Node may surface `{ default: ReactPlayer }` instead of the component
const ReactPlayer =
  (ReactPlayerImport as { default?: typeof ReactPlayerImport }).default ??
  ReactPlayerImport;

function PlayBadge() {
  return (
    <span className="flex size-16 items-center justify-center rounded-full bg-black/40">
      <Play className="ml-1 size-7 fill-white text-white" aria-hidden />
    </span>
  );
}

export function VideoPin({ pin, autoPlay }: PinRendererProps) {
  const url = pin.url ?? '';
  const src =
    pin.pin_type === 'file' ? convertVideoFileWithCloudinary(url) : url;
  const cover = getVideoCoverImage(url);
  return (
    <div className="aspect-video w-full overflow-hidden rounded-xl bg-black">
      <ReactPlayer
        url={src}
        width="100%"
        height="100%"
        playing={autoPlay}
        controls
        light={autoPlay || !cover ? false : cover}
        playIcon={<PlayBadge />}
        config={{ file: { attributes: { preload: 'metadata' } } }}
      />
    </div>
  );
}
